module.exports = __webpack_public_path__ + "static/media/ylcard.00535d62.png";